import React, {Fragment, useCallback, useState} from 'react';
import {Form, Formik} from 'formik';
import Button from '@mui/material/Button';
import axios from 'axios';
import {FormControl, InputLabel, Select, Stack} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import {AlertDialog, FormDialog, toast, EmptyState} from "@lb/mlib-components";
import TableChartOutlinedIcon from "@mui/icons-material/TableChartOutlined";
import {DateTime} from "luxon";
import dayjs from 'dayjs';
import {DatePicker} from '@mui/x-date-pickers/DatePicker';

const initialValues = {
    endDate: DateTime.now().toFormat("yyyy-LL-dd"),
    startDate: DateTime.now().minus({days: 7}).toFormat("yyyy-LL-dd"),
};

const formId = 'sample-orders-report-form';

const excelDateToEpoch = (excelDate) => {
    return new Date(excelDate).getTime() / 1000;
};


export default function SamplesReport(props) {

    const [dealer, setDealer] = useState('all');
    const [noOrders, setNoOrders] = useState(false);
    const [open, setOpen] = React.useState(false);
    // Mirrors Formik's date fields so the Download button (rendered via FormDialog's
    // `actions` prop, outside the Formik render-prop scope) can read them for `disabled`.
    const [startDateInput, setStartDateInput] = useState(initialValues.startDate);
    const [endDateInput, setEndDateInput] = useState(initialValues.endDate);

    const handleClose = () => {
        setOpen(false);
        props.handleClose();
    };
    const handleOpen = () => setOpen(true);

    function handleChangeDealer(event) {
        setDealer(event.target.value)
        setNoOrders(false)
    }

    const handleDownload = useCallback(async (values) => {
        const {startDate, endDate} = values;
        const startDateStr = startDate ? excelDateToEpoch(startDate) : '';
        const endDateStr = endDate ? excelDateToEpoch(endDate) : '';

        let data = {
            start: startDateStr,
            end: endDateStr
        }
        let url = `samples/excel`;
        if (dealer !== 'all')
            data = {...data, isdealer: dealer === 'isdealer'}

        axios.post(url, data, {
            responseType: 'blob', headers: {'Error-Message': ''}
        }).then((response) => {

            const filename = `samples_${startDate}_${endDate}.xlsx`;
            const urlObject = window.URL || window.webkitURL;
            const downloadUrl = urlObject.createObjectURL(response.data);
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            setTimeout(() => {
                document.body.removeChild(link);
                urlObject.revokeObjectURL(downloadUrl);
            }, 100);

        }).catch((error) => {
            if (error.response?.status === 404) {
                setNoOrders(true)
            } else toast.error('There was an error processing your request.', {
                action: key => (<AlertDialog message={error.response?.data?.detail || error.toString()}
                                             key={key}/>),
            });

        });

    }, [dealer])


    return (
        <Fragment>
            <Button color="primary" variant={'outlined'} startIcon={<TableChartOutlinedIcon/>} onClick={handleOpen}>
                Report
            </Button>

            <FormDialog
                title="Download Report"
                open={open}
                onClose={handleClose}
                active={false}
                actions={
                    <Button type="submit" form={formId}
                            disabled={startDateInput.length === 0 || endDateInput.length === 0}
                            variant="contained" color="primary"
                            startIcon={<DownloadIcon/>}
                    >
                        Download
                    </Button>
                }
            >
                <Formik initialValues={initialValues} onSubmit={handleDownload}>
                    {(form) => (
                        <Form id={formId}>
                            <Stack direction={'row'} spacing={2}>
                                <DatePicker
                                    label="Start Date"
                                    value={form.values.startDate ? dayjs(form.values.startDate) : null}
                                    onChange={(newValue) => {
                                        const value = newValue ? newValue.format('YYYY-MM-DD') : '';
                                        form.setFieldValue('startDate', value)
                                        setStartDateInput(value)
                                        setNoOrders(false)
                                    }}
                                />
                                <DatePicker
                                    label="End Date"
                                    value={form.values.endDate ? dayjs(form.values.endDate) : null}
                                    onChange={(newValue) => {
                                        const value = newValue ? newValue.format('YYYY-MM-DD') : '';
                                        form.setFieldValue('endDate', value)
                                        setEndDateInput(value)
                                        setNoOrders(false)
                                    }}
                                />
                                <FormControl sx={{width: '200px'}} variant={"filled"}>
                                    <InputLabel id="demo-simple-select-label">Filter by store</InputLabel>
                                    <Select
                                        id="outlined-select-warehouse"
                                        label="Filter by store"
                                        value={dealer}
                                        onChange={handleChangeDealer}
                                        fullWidth
                                    >
                                        <MenuItem value={'all'}>
                                            All
                                        </MenuItem>
                                        <MenuItem value={'isdealer'}>
                                            Dealers
                                        </MenuItem>
                                        <MenuItem value={'public'}>
                                            Public
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                            </Stack>
                            {noOrders && <Box sx={{mt: 2}}><EmptyState message="No orders to show."/></Box>}
                        </Form>
                    )}
                </Formik>
            </FormDialog>
        </Fragment>
    );
};
